/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ProjectOptimizeSuccessDtoBase
 * auto generated base class for the model ProjectOptimizeSuccessDtoModel.
 *
 * Optimize success
 */
export const ProjectOptimizeSuccessDtoModelBase = ModelBase
  .named('ProjectOptimizeSuccessDto')
  .props({
    __typename: types.optional(types.literal("ProjectOptimizeSuccessDto"), "ProjectOptimizeSuccessDto"),
    projectId: types.union(types.undefined, types.string),
    solutionId: types.union(types.undefined, types.string),
    /** Count of scheduled stops */
    scheduledStops: types.union(types.undefined, types.number),
    /** Count of unscheduled stops */
    unscheduledStops: types.union(types.undefined, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ProjectOptimizeSuccessDtoModelSelector extends QueryBuilder {
  get projectId() { return this.__attr(`projectId`) }
  get solutionId() { return this.__attr(`solutionId`) }
  get scheduledStops() { return this.__attr(`scheduledStops`) }
  get unscheduledStops() { return this.__attr(`unscheduledStops`) }
}
export function selectFromProjectOptimizeSuccessDto() {
  return new ProjectOptimizeSuccessDtoModelSelector()
}

export const projectOptimizeSuccessDtoModelPrimitives = selectFromProjectOptimizeSuccessDto().projectId.solutionId.scheduledStops.unscheduledStops
